import { Examination, Trial_File_Type } from "@generated/graphql";

export const getTestingTitle = (examination: Pick<Examination, "numericId" | "title"> | undefined) =>
  // eslint-disable-next-line max-len
  `Тестирование${examination?.title ? ` ${examination.title},` : ""}${examination?.numericId ? ` ID ${examination?.numericId}` : ""}`;

export const getExaminationSendResultType = (isExtendedReport?: boolean) => {
  if (isExtendedReport) return Trial_File_Type.RecruiterReport;
  return Trial_File_Type.CandidateReport;
};

export const getExaminationIsExtendedReport = (trialFileType?: Trial_File_Type) => {
  if (trialFileType === Trial_File_Type.RecruiterReport) return true;
  return false;
};
